import { ValueFormatterParams } from 'ag-grid-community';
import { isNil } from 'lodash';

export const percentFormatter = (
  params: ValueFormatterParams,
  decimalPlaces?: number
) => {
  if (isNil(params.value)) return '';

  let numValue =
    typeof params.value === 'string' ? parseFloat(params.value) : params.value;
  if (isNaN(numValue)) return '';

  if (Object.is(numValue, -0)) {
    numValue = 0;
  }

  return `${
    decimalPlaces
      ? numValue.toLocaleString('en-US', {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces,
        })
      : numValue.toLocaleString('en-US')
  }%`;
};

export const numberFormatter = (
  params: ValueFormatterParams,
  decimalPlaces?: number
) => {
  if (isNil(params.value)) return '';

  let numValue =
    typeof params.value === 'string' ? parseFloat(params.value) : params.value;
  if (isNaN(numValue)) return '';

  if (Object.is(numValue, -0)) {
    numValue = 0;
  }

  return !isNil(decimalPlaces)
    ? numValue.toLocaleString('en-US', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      })
    : numValue.toLocaleString('en-US');
};
